import { render, staticRenderFns } from "./u-line.vue?vue&type=template&id=e778bab2&scoped=true&"
import script from "./u-line.vue?vue&type=script&lang=js&"
export * from "./u-line.vue?vue&type=script&lang=js&"
import style0 from "./u-line.vue?vue&type=style&index=0&id=e778bab2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e778bab2",
  null
  
)

component.options.__file = "node_modules/uview-ui/components/u-line/u-line.vue"
export default component.exports